import { useState } from "react"
import { errorToast } from "@/v2-ui/toast"
import Manage from "@/v2-backoffice-client/components/manage"
import { ConfirmButton } from "@/v2-backoffice-client/components/button"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"
import UserTenantTypePicker from "@/v2-backoffice-client/user/tenant/type/UserTenantTypePicker"
import { useTenantUserAddMutation } from "@/v2-backoffice-client/tenant/user/add/tenant.user.add.mutation"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import { DEFAULT_TENANT_USER_TYPE_CODE } from "@/v2-backoffice-client/tenant/user/tenant.user.constants"

export type TenantUserManageSearchItemProps = {
  user: UserFragment
  tenantId: number
  onAdded(roleCode: number): void
}

function TenantUserManageSearchItem(props: TenantUserManageSearchItemProps) {
  const { user, tenantId, onAdded } = props

  const [roleCode, setRoleCode] = useState(DEFAULT_TENANT_USER_TYPE_CODE)
  const [add, { error, loading }] = useTenantUserAddMutation()

  errorToast(error, { title: "Failed to add user to team" })

  function handleAdd() {
    add({
      variables: {
        tenantId,
        userId: user.Id,
        userTenantTypeCode: roleCode,
      },
    })
    onAdded(roleCode)
  }

  const isRemoved = user.UserStatus.Name === "Removed"

  return (
    <Manage.Item>
      <Manage.Item.Text
        primary={formatUserName(user.FirstName, user.LastName)}
        secondary={user.Email ?? undefined}
        tag={isRemoved ? "removed" : undefined}
      />
      <UserTenantTypePicker value={roleCode} onChange={setRoleCode} size="xs" />
      <ConfirmButton
        size="xs"
        variant="ghost"
        isSquare
        iconSrc="plus"
        content="Add user to team"
        confirmContent="Add?"
        isLoading={loading}
        onConfirm={handleAdd}
      />
    </Manage.Item>
  )
}

export default TenantUserManageSearchItem
